var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChorusone = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 44,
    viewBox: "0 0 152 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_129_10418",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 7,
    width: 112,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.798 7H19.4502V37H130.798V7Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_129_10418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.6791 20.4699C64.6437 20.4699 66.9513 19.0087 67.214 15.7302H64.4745C64.0806 17.3788 63.03 18.0532 61.6791 18.0532C59.3712 18.0532 58.4519 16.1798 58.4519 13.7256C58.4519 11.2714 59.3902 9.41675 61.6791 9.41675C63.0487 9.41675 64.0806 10.0912 64.4745 11.721H67.214C66.9513 8.46125 64.6437 7 61.6791 7C57.964 7 55.5625 9.49167 55.5625 13.7256C55.5625 17.9783 57.964 20.4699 61.6791 20.4699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4646 20.4699C91.2546 20.4699 93.7311 17.7347 93.7311 13.7256C93.7311 9.69775 91.2546 7 87.4646 7C83.6746 7 81.1973 9.69775 81.1973 13.7256C81.1973 17.7347 83.6746 20.4699 87.4646 20.4699ZM87.4646 18.0532C85.3063 18.0532 84.0865 16.3297 84.0865 13.7256C84.0865 11.1028 85.3063 9.41675 87.4646 9.41675C89.6221 9.41675 90.841 11.1028 90.841 13.7256C90.841 16.3297 89.6221 18.0532 87.4646 18.0532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.755 20.4703C115.944 20.4703 118.158 18.803 118.158 15.2996V7.16895H115.325V15.0935C115.325 17.0419 114.368 18.0348 112.755 18.0348C111.141 18.0348 110.165 17.0419 110.165 15.0935V7.16895H107.332V15.2996C107.332 18.803 109.527 20.4703 112.755 20.4703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.319 20.4699C128.302 20.4699 130.647 19.2522 130.647 16.4233C130.647 14.4375 129.465 13.2572 126.388 12.6765L124.624 12.3393C123.442 12.1332 123.123 11.4962 123.123 10.8967C123.123 10.0912 123.687 9.32308 125.187 9.32308C126.464 9.32308 127.439 9.84758 127.401 11.0278H130.291C130.291 8.34883 128.151 7 125.15 7C122.204 7 120.178 8.27392 120.178 10.7843C120.178 13.1636 121.923 14.1002 123.986 14.5124L125.882 14.8684C127.064 15.0932 127.664 15.5428 127.664 16.4421C127.664 17.5099 126.857 18.1469 125.338 18.1469C123.536 18.1469 122.786 17.1727 122.73 15.9924H119.821C119.821 18.8776 121.96 20.4699 125.319 20.4699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1084 7.2998V12.6072H74.3447V14.8924H77.1084V20.1998H79.9389V7.2998H77.1084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9371 12.6072V14.8924V20.1998H69.1055V7.2998H71.9371V12.6072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5588 36.6998H81.4023V23.7998H90.3713V26.1956H84.217V29.0888H89.8079V31.245H84.217V34.3041H90.5588V36.6998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8293 36.9701C65.6193 36.9701 68.0958 34.2348 68.0958 30.2257C68.0958 26.1978 65.6193 23.5 61.8293 23.5C58.0393 23.5 55.5625 26.1978 55.5625 30.2257C55.5625 34.2348 58.0393 36.9701 61.8293 36.9701ZM61.8293 34.5533C59.6716 34.5533 58.4519 32.8298 58.4519 30.2257C58.4519 27.6028 59.6716 25.9168 61.8293 25.9168C63.9868 25.9168 65.2064 27.6028 65.2064 30.2257C65.2064 32.8298 63.9868 34.5533 61.8293 34.5533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.459 33.6618L22.8173 36.9944L26.1756 33.6618L22.8173 30.3291L19.459 33.6618Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6836 10.3327L46.3251 7L42.9668 10.3327L46.3251 13.6654L49.6836 10.3327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9294 25.3295L34.571 28.6623L31.2128 25.3295L27.8544 21.9969L31.2128 18.6642L34.571 15.3314L37.9294 18.6642L41.2877 21.9969L37.9294 25.3295ZM48.0044 21.9968L44.6461 18.6641L41.2877 15.3313L37.9293 11.9987L34.571 8.66602L31.2127 11.9987L27.8543 15.3313L24.4961 18.6641L21.1377 21.9968L24.4961 25.3295L27.8543 28.6622L31.2127 31.9949L34.571 35.3275L37.9293 31.9949L41.2877 28.6622L44.6461 25.3295L48.0044 21.9968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9629 33.6676L46.3212 37.0003L49.6795 33.6676L46.3212 30.335L42.9629 33.6676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1669 10.3356L22.8086 7.00293L19.4502 10.3356L22.8086 13.6683L26.1669 10.3356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8559 23.7998H69.1055V36.6998H71.855V28.3886L71.8559 23.7998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2637 32.2536L76.9704 36.6998H79.9399V23.7998H77.1905V32.277H77.1353L74.2637 27.568V32.2536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.096 15.5432L105.854 20.283H103.078L100.625 15.9929V13.4824C102.16 13.4806 102.834 12.7129 102.834 11.5528C102.834 10.3725 102.158 9.60436 100.62 9.60436H98.2181V12.531V16.2415V20.283H95.4043V7.16895H100.714C104.203 7.16895 105.724 8.98619 105.724 11.5528C105.724 13.4262 104.917 14.8874 103.096 15.5432Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChorusone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chorusone.9703766c1a85aa599de3bea3c4aa4319.svg";